interface IEnergyPerformance {
    co2_emission_unit: number | null;
    final_energy_indicator: number | null;
    primary_energy_indicator: number | null;
    renewable_energy_sources: number | null;
    usable_energy_indicator: number | null;
}

const sup = (value: number | string) => `<sup>${value}</sup>`;
const sub = (value: number | string) => `<sub>${value}</sub>`;

const metersPerYear = `(m${sup(2)} * rok)`;
const kilowattHour = `kWh/${metersPerYear}`;

const energyPerformanceTypes: {key: keyof IEnergyPerformance; label: string; getValue: (value: number) => string}[] = [
    {
        key: "co2_emission_unit",
        label: "Jednostkowa wielkość emisji CO2 (E CO2)",
        getValue: (value: number) => `E${sub("CO" + sub(2))}= ${value} t CO${sub(2)}/${metersPerYear}`
    },
    {
        key: "final_energy_indicator",
        label: "Wskaźnik rocznego zapotrzebowania na energię końcową (EK)",
        getValue: (value: number) => `EK= ${value} ${kilowattHour}`
    },
    {
        key: "primary_energy_indicator",
        label: "Wskaźnik rocznego zapotrzebowania na nieodnawialną energię pierwotną (EP)",
        getValue: (value: number) => `EP= ${value} ${kilowattHour}`
    },
    {
        key: "renewable_energy_sources",
        label: "Udział odnawialnych źródeł energii w rocznym zapotrzebowaniu na energię końcową (U OZE)",
        getValue: (value: number) => `U${sub("OZE")}= ${value}%`
    },
    {
        key: "usable_energy_indicator",
        label: "Wskaźnik rocznego zapotrzebowania na energię użytkową (EU)",
        getValue: (value: number) => `EU= ${value} ${kilowattHour}`
    }
];

export const getEnergyPerformanceValues = (data: IEnergyPerformance) => {
    return energyPerformanceTypes.reduce<{key: string; label: string; value: string}[]>((acc, type) => {
        const value = data[type.key];

        if (typeof value === "number" && isFinite(value)) {
            acc.push({key: type.key, label: type.label, value: type.getValue(value)});
        }

        return acc;
    }, []);
};
interface IEnergyPerformance {
    co2_emission_unit: number | null;
    final_energy_indicator: number | null;
    primary_energy_indicator: number | null;
    renewable_energy_sources: number | null;
    usable_energy_indicator: number | null;
}

const sup = (value: number | string) => `<sup>${value}</sup>`;
const sub = (value: number | string) => `<sub>${value}</sub>`;

const metersPerYear = `(m${sup(2)} * rok)`;
const kilowattHour = `kWh/${metersPerYear}`;

const energyPerformanceTypes: {key: keyof IEnergyPerformance; label: string; getValue: (value: number) => string}[] = [
    {
        key: "co2_emission_unit",
        label: "Jednostkowa wielkość emisji CO2 (E CO2)",
        getValue: (value: number) => `E${sub("CO" + sub(2))}= ${value} t CO${sub(2)}/${metersPerYear}`
    },
    {
        key: "final_energy_indicator",
        label: "Wskaźnik rocznego zapotrzebowania na energię końcową (EK)",
        getValue: (value: number) => `EK= ${value} ${kilowattHour}`
    },
    {
        key: "primary_energy_indicator",
        label: "Wskaźnik rocznego zapotrzebowania na nieodnawialną energię pierwotną (EP)",
        getValue: (value: number) => `EP= ${value} ${kilowattHour}`
    },
    {
        key: "renewable_energy_sources",
        label: "Udział odnawialnych źródeł energii w rocznym zapotrzebowaniu na energię końcową (U OZE)",
        getValue: (value: number) => `U${sub("OZE")}= ${value}%`
    },
    {
        key: "usable_energy_indicator",
        label: "Wskaźnik rocznego zapotrzebowania na energię użytkową (EU)",
        getValue: (value: number) => `EU= ${value} ${kilowattHour}`
    }
];

export const getEnergyPerformanceValues = (data: IEnergyPerformance) => {
    return energyPerformanceTypes.reduce<{key: string; label: string; value: string}[]>((acc, type) => {
        const value = data[type.key];

        if (typeof value === "number" && isFinite(value)) {
            acc.push({key: type.key, label: type.label, value: type.getValue(value)});
        }

        return acc;
    }, []);
};
